module.exports = __webpack_public_path__ + "img/sales.9e65cb1f.png";